import { Skeleton } from "@circleco/compass/components/Skeleton";
import { TypographySkeleton } from "@circleco/compass/components/TypographySkeleton";

const CompassSidebarLoader = () => (
  <div className="border-primary bg-primary col-span-full flex flex-col items-center overflow-auto border-r px-6 pb-10 pt-8 md:col-span-4">
    <Skeleton shape="rounded" className="size-[152px]" />
    <div className="mt-6 flex w-full flex-col items-center gap-4">
      <TypographySkeleton variant="label-lg" className="w-48" />
      <Skeleton shape="rounded" className="h-6 w-24" />
    </div>
  </div>
);

const CompassBodyLoader = () => (
  <div className="bg-primary col-span-12 flex flex-col overflow-auto p-8 md:col-span-8">
    <div className="flex items-center gap-2 pb-7 pt-2">
      <Skeleton shape="rounded" className="h-9 w-16" />
      <Skeleton shape="rounded" className="h-9 w-28" />
    </div>
    <div className="flex w-full flex-col gap-3">
      <TypographySkeleton variant="label-sm" className="w-10" />
      <TypographySkeleton
        variant="body-sm"
        lines={3}
        className="w-full space-y-1"
      />
    </div>
  </div>
);

export const CompassLoader = () => (
  <>
    <CompassSidebarLoader />
    <CompassBodyLoader />
  </>
);
